var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTilesView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0714 1H2.92857C2.41708 1 1.92654 1.20319 1.56487 1.56487C1.20319 1.92654 1 2.41708 1 2.92857V17.0714C1 17.5829 1.20319 18.0735 1.56487 18.4351C1.92654 18.7968 2.41708 19 2.92857 19H17.0714C17.5829 19 18.0735 18.7968 18.4351 18.4351C18.7968 18.0735 19 17.5829 19 17.0714V2.92857C19 2.41708 18.7968 1.92654 18.4351 1.56487C18.0735 1.20319 17.5829 1 17.0714 1ZM6.78571 17.7143H2.92857C2.75808 17.7143 2.59456 17.6466 2.474 17.526C2.35344 17.4054 2.28571 17.2419 2.28571 17.0714V13.8571H6.78571V17.7143ZM6.78571 12.5714H2.28571V8.07143H6.78571V12.5714ZM6.78571 6.78571H2.28571V2.92857C2.28571 2.75808 2.35344 2.59456 2.474 2.474C2.59456 2.35344 2.75808 2.28571 2.92857 2.28571H6.78571V6.78571ZM12.5714 17.7143H8.07143V13.8571H12.5714V17.7143ZM12.5714 12.5714H8.07143V8.07143H12.5714V12.5714ZM12.5714 6.78571H8.07143V2.28571H12.5714V6.78571ZM17.7143 17.0714C17.7143 17.2419 17.6466 17.4054 17.526 17.526C17.4054 17.6466 17.2419 17.7143 17.0714 17.7143H13.8571V13.8571H17.7143V17.0714ZM17.7143 12.5714H13.8571V8.07143H17.7143V12.5714ZM17.7143 6.78571H13.8571V2.28571H17.0714C17.2419 2.28571 17.4054 2.35344 17.526 2.474C17.6466 2.59456 17.7143 2.75808 17.7143 2.92857V6.78571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTilesView);
export default __webpack_public_path__ + "static/media/tiles-view.f97fc1cf3b6d32be07425a7bd831b1f5.svg";
export { ForwardRef as ReactComponent };